import { useEffect } from 'react';
import './Modal.css';

export default function Modal({ isOpen, onClose, title, children, type = 'info', actions, contentClassName = '' }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'confirm':
        return '?';
      default:
        return 'ℹ';
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content modal-${type}${contentClassName ? ` ${contentClassName}` : ''}`} onClick={e => e.stopPropagation()}>
        <div className="modal-icon">
          <span>{getIcon()}</span>
        </div>
        
        {title && <h2 className="modal-title">{title}</h2>}
        
        <div className="modal-body">
          {children}
        </div>
        
        <div className="modal-actions">
          {actions || (
            <button onClick={onClose} className="modal-button modal-button-primary">
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
